import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/7e0f57776b8e27a3e2ebe4c4e27fc573.jpg',
    titleKey: 'onboarding1_title',
    descKey: 'onboarding1_desc'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=smartphone%20showing%20GPS%20map%20tracking%20location%20of%20flatbed%20truck%20in%20real-time%20mobile%20app%20interface%20modern%20technology%20realistic%20photo%20high%20quality%20centered%20composition&width=375&height=400&seq=onboard2&orientation=portrait',
    titleKey: 'onboarding2_title',
    descKey: 'onboarding2_desc'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=transparent%20pricing%20calculator%20showing%20cost%20breakdown%20for%20vehicle%20transport%20service%20professional%20business%20illustration%20modern%20clean%20design%20centered%20composition&width=375&height=400&seq=onboard3&orientation=portrait',
    titleKey: 'onboarding3_title',
    descKey: 'onboarding3_desc'
  }
];

export default function OnboardingPage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      navigate('/language-select');
    }
  };

  const handleSkip = () => {
    navigate('/language-select');
  };

  return (
    <div className="fixed inset-0 bg-[#F6F7FB] flex flex-col" style={{ width: '375px', height: '812px', margin: '0 auto' }}>
      {/* Skip Button */}
      <div className="absolute top-6 right-6 z-10">
        <button
          onClick={handleSkip}
          className="text-[#0F6CBD] font-medium text-sm px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm shadow-sm"
        >
          {t('skip')}
        </button>
      </div>

      {/* Slide Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 pt-16 pb-8">
        <div className="w-full h-96 mb-8 rounded-3xl overflow-hidden shadow-lg">
          <img
            src={slides[currentSlide].image}
            alt={t(slides[currentSlide].titleKey)}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <h2 className="text-2xl font-bold text-[#0F172A] mb-4 text-center">
          {t(slides[currentSlide].titleKey)}
        </h2>
        <p className="text-[#64748B] text-center leading-relaxed px-4">
          {t(slides[currentSlide].descKey)}
        </p>
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mb-6">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'w-8 bg-[#0F6CBD]' : 'w-2 bg-[#CBD5E1]'
            }`}
          />
        ))}
      </div>

      {/* Next Button */}
      <div className="px-6 pb-8">
        <button
          onClick={handleNext}
          className="w-full bg-[#0F6CBD] text-white py-4 rounded-2xl font-semibold text-lg shadow-lg shadow-[#0F6CBD]/20 active:scale-95 transition-transform"
        >
          {currentSlide === slides.length - 1 ? t('get_started') : t('next')}
        </button>
      </div>
    </div>
  );
}